var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.plan !== null)?_c('v-container',{attrs:{"fluid":""}},[(_vm.plan.plan_type === 'COSTOS')?_c('CostPlanForm',{attrs:{"plan":_vm.plan,"edit":""}}):_c('PlanForm',{attrs:{"plan":_vm.plan,"edit":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }